import Add from "@mui/icons-material/Add";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Button from "@mui/material/Button";
import { useCallback } from "react";
import CreateWorkspaceDialog from "../useDialogs/CreateWorkspaceDialog";
import { useDialogs } from "../useDialogs/useDialogs";
import WorkspaceRoleDialog from "../useDialogs/WorkspaceRoleDialog";
import PageHeader from "./PageHeader";
import PageHeaderToolbar from "./PageHeaderToolbar";
function WorkspacePageToolbar({
  isAdmin,
  isManager,
  workspaceId,
  workspaceName,
  workspaceUsers,
}: {
  isAdmin: boolean;
  isManager: boolean;
  workspaceId: string;
  workspaceName: string;
  workspaceUsers: string[];
}) {
  const dialogs = useDialogs();
  //Probably payload will be manager info
  return (
    <PageHeaderToolbar>
      {isManager && (
        <Button
          variant="contained"
          className="flex items-center gap-2"
          onClick={async () =>
            await dialogs.open(WorkspaceRoleDialog, {
              workspaceId,
              workspaceName,
              workspaceUsers,
            })
          }
        >
          <PersonAdd />
          Inviter
        </Button>
      )}
      {isAdmin && (
        <Button
          variant="contained"
          className="flex items-center gap-2"
          onClick={() => dialogs.open(CreateWorkspaceDialog)}
        >
          <Add />
          Créer un espace
        </Button>
      )}
    </PageHeaderToolbar>
  );
}
function WorkspacePageHeader({
  isAdmin,
  isManager,
  workspaceId,
  workspaceName,
  workspaceUsers,
}: {
  isAdmin: boolean;
  isManager: boolean;
  workspaceId: string;
  workspaceName: string;
  workspaceUsers: string[];
}) {
  const PageToolbarComponent = useCallback(
    () =>
      (isManager || isAdmin) && (
        <WorkspacePageToolbar
          isManager={isManager}
          isAdmin={isAdmin}
          workspaceId={workspaceId}
          workspaceName={workspaceName}
          workspaceUsers={workspaceUsers}
        />
      ),
    [isManager, isAdmin, workspaceId, workspaceName, workspaceUsers]
  );
  return (
    <PageHeader slots={{ toolbar: PageToolbarComponent }} breadcrumbs={null} />
  );
}

export default WorkspacePageHeader;
